import IRDetector from "../IRDetector/IRDetector"
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./IrOrUserSelector.sass";
import logo from "./logo.png";

const IrOrUserSelector = () => {
  const { t } = useTranslation();
  const irOrUserSelectorClosed = sessionStorage.getItem('irOrUserSelectorClosed');

  const close = () => {
    const dialog = document.querySelector('.select-dialog');
    if (dialog) {
      dialog.classList.add('select-dialog--hidden');
      sessionStorage.setItem('irOrUserSelectorClosed', 'true');
      setTimeout(() => {
        dialog.remove();
      }, 300);
    }
  }

  const goToIR = () => {
    const url = window.location.href;
    const irUrl = url.replace(/^(https?:\/\/)?(www\.)?/, 'https://ir.');
    window.location.href = irUrl;
  }

  return (
    <IRDetector>
      <div className="select-dialog" style={{ display: irOrUserSelectorClosed ? 'none' : 'flex' }}>
        <div className="select-dialog__logo">
          <img src={logo} alt="BluHolding" />
        </div>
        <div className="select-dialog__container">
          <div className="select-dialog__option" onClick={goToIR}>
            <span className="select-dialog__option__title">{t("redirect.investor")}</span>
            <svg className="select-dialog__option__arrow" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
          </div>
          <div className="select-dialog__option" onClick={close}>
            <span className="select-dialog__option__title">{t("redirect.client")}</span>
            <svg className="select-dialog__option__arrow" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
          </div>
        </div>
      </div>
    </IRDetector>
  )
}

export default IrOrUserSelector;